import { render } from "./A6CardPolicy.vue?vue&type=template&id=48ee7e4d&scoped=true"
import script from "./A6CardPolicy.vue?vue&type=script&lang=js"
export * from "./A6CardPolicy.vue?vue&type=script&lang=js"

import "./A6CardPolicy.vue?vue&type=style&index=0&id=48ee7e4d&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ee7e4d"]])

export default __exports__